
import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function BenefitsSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('benefits-section');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const handleJoinGroup = () => {
    const formElement = document.getElementById('networking-form-section');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const benefits = [
    {
      icon: 'ri-team-fill',
      title: 'Conecta con emprendedores reales',
      description: 'Red de contactos verificados y activos en el ecosistema empresarial'
    },
    {
      icon: 'ri-lightbulb-fill',
      title: 'Descubre oportunidades de colaboración',
      description: 'Proyectos conjuntos, inversiones y alianzas estratégicas'
    },
    {
      icon: 'ri-line-chart-fill',
      title: 'Aprende sobre crédito y crecimiento',
      description: 'Conocimiento exclusivo para escalar tu negocio de forma inteligente'
    },
    {
      icon: 'ri-global-fill',
      title: 'Acceso a eventos y comunidad VIP',
      description: 'Participación en eventos exclusivos y acceso a la plataforma Skool'
    }
  ];

  return (
    <section id="benefits-section" className="py-12 sm:py-16 lg:py-20 bg-yellow-400">
      <div className="container mx-auto px-4 sm:px-6">
        <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-black mb-4 sm:mb-6">
            Por qué unirte al grupo VIP
          </h2>
          <p className="text-lg sm:text-xl text-black/80 max-w-3xl mx-auto px-4">
            Beneficios exclusivos que transformarán tu red de contactos y oportunidades de negocio
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className={`bg-black rounded-xl sm:rounded-2xl p-6 sm:p-8 transition-all duration-1000 delay-${index * 100} ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-6">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${benefit.icon} text-black text-xl sm:text-2xl`}></i>
                </div>
                
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-yellow-400 mb-2 sm:mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="bg-black rounded-xl sm:rounded-2xl p-8 sm:p-12 max-w-4xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold text-yellow-400 mb-4 sm:mb-6">
              ¿Listo para expandir tu red de contactos?
            </h3>
            <p className="text-lg sm:text-xl text-gray-300 mb-6 sm:mb-8">
              Únete a emprendedores que están creciendo juntos
            </p>
            <Button 
              size="lg" 
              onClick={handleJoinGroup}
              className="text-lg sm:text-xl px-8 sm:px-12 py-4 sm:py-6 w-full sm:w-auto whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill mr-2 sm:mr-3 text-xl sm:text-2xl"></i>
              Acceder al grupo ahora
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
